import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer">
            <div className="footer-inner">
                <div className="footer-brand">
                    <span className="footer-logo-text">Launch<span className="footer-logo-accent">way</span></span>
                    <p className="footer-tagline">
                        Finds better roles, tailors your real resume, and helps you apply step by step.
                    </p>
                </div>

                <div className="footer-col-group">
                    <div className="footer-col">
                        <h4>Product</h4>
                        <ul>
                            <li><Link to="/profile">Manage Profile</Link></li>
                            <li><Link to="/manage-credits">Manage Credits</Link></li>
                        </ul>
                    </div>

                    <div className="footer-col">
                        <h4>Legal</h4>
                        <ul>
                            <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                            <li><Link to="/terms-of-service">Terms of Service</Link></li>
                        </ul>
                    </div>

                    <div className="footer-col">
                        <h4>Help</h4>
                        <ul>
                            <li><a href="mailto:launchway@tailor-mycareer.online">Contact</a></li>
                            <li><Link to="/report-bug">Report a Bug</Link></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="footer-bottom">
                <p>© {currentYear} Launchway. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;
